import React, { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import styles from './CurrentWeatherConditions.module.scss';

interface Props {
  spotName: string;
  units?: string;
  weather: {
    condition?: string;
    temperature?: number;
  };
  weatherIconPath: string;
}

const CurrentWeatherConditions: FC<Props> = ({
  spotName,
  units = 'f',
  weather = { condition: 'CLEAR_NO_RAIN', temperature: 0 },
  weatherIconPath,
}) => (
  <Box>
    <Stack direction="row" className={styles.wrapper}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`${weatherIconPath}/${weather.condition}.svg`}
        alt={`${spotName} Wind & Weather`}
        className={styles.icon}
      />
      <Box>
        <Typography variant="title2" component="span" className={styles.temperature}>
          {weather.temperature}
        </Typography>
        <Typography variant="headline" component="span" className={styles.units}>
          º{units}
        </Typography>
      </Box>
    </Stack>
  </Box>
);

export default CurrentWeatherConditions;
